module.exports = __webpack_public_path__ + "static/media/left-top.30c89146.svg";